module.exports = __webpack_public_path__ + "static/media/GT06_GT_Boards.494013b7.csv";